module.exports = __webpack_public_path__ + "img/operators__cover.b8392d67.png";